import Link from 'next/link'
import React from 'react'

type Props = {}

function ContactCard({}: Props) {
  return (
    <>
      <div className="custom-block custom-block-contact">
        <h6 className="mb-4">Still can’t find what you’re looking for?</h6>

        <p>
          <strong>Call us:</strong>
          <a href="tel:+234-807-966-4791" className="ms-2">
            +(234) 807 966 4791
          </a>
        </p>

        <Link
          prefetch
          target="_blank"
          href="https://wa.me/+2348079664791"
          className="btn custom-btn custom-btn-bg-white mt-3"
        >
          Chat with us
        </Link>
      </div>
    </>
  )
}

export default ContactCard
